import React from "react";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { setFormSecondaryAction } from "../../../../store/actions";
import useAccountPaymentActions from "../Actions";
import { useDispatch } from "react-redux"

const AccountPaymentActions = (props) => {
  const { form } = props;
  const { loading } = useSelector(state => state.ApiStatus);
  const { doConfirm, doPrint } = useAccountPaymentActions(form.fields.id);
  const dispatch = useDispatch();

  return (
    <Row className="mb-2">
      <Col>
      {form.fields?.state === 1 ? (
           <Button
             color="primary"
             className="btn btn-primary btn-sm me-1"
             type="submit"
              form="hook-form"
              onClick={() => { dispatch(setFormSecondaryAction('confirm')) }}
             disabled={loading}
           >
             Confirmar
           </Button>
          ) : null}
      {form.fields?.id != 0 ? (
        <React.Fragment>
            <Button
              color="primary"
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                e.preventDefault();
                doPrint(form.fields.name);
              }}
              disabled={loading}
            >
              Imprimir
            </Button>
          
        </React.Fragment>
      ) : null}
      </Col>
    </Row>
  );
};

export default AccountPaymentActions;
